import axios, { Axios } from "axios";
import { useEffect, useState } from "react";
// import data from "../../utils/constants/indonesia";
import StyleCard from "./Card.Module";



function Card() {
    // const { card } = props;
   
    
    // const atas = (
    //     <div className={styles.cards__one}>
    //         {props.data.map((post) => 
    //             <h1 key={post.status}>{post.status}</h1>
                
    //         ) }
    //     </div> 
    // );


    // const bawah = (
    //     <div className={styles.cards__one}>
    //         {props.data.map((post) => 
    //             <h1 className={styles.cards__descOne} value="" key={post.total}>{post.total}</h1>
                
    //         ) }
            
    //     </div> 
    // );


    // const model = data.map((n) => {
        
    // })

    //coba dulu satu persatu component

    
    const [sum, setSum] = useState('');

    async function fetchData(){
        const response = await fetch( 
            "https://covid19.mathdro.id/api/"
    
        );
    
        const data = await response.json();
        console.log(data);
    
        setSum(data);
    
        //menjabarkan data JSON lalu dikembalikan 
        const { data : {confirmed, recovered, deaths, lastUpdate}} = await axios(URL);
        
        return { confirmed, recovered, deaths, lastUpdate };
    
        // const modifiedData = {
        //     confirmed: confirmed,
        //     recovered: recovered,
        //     deaths: deaths,
        //     lastUpdate: lastUpdate,
    
            
        // }
    
    
        // return modifiedData;
    
        // this.setSum({data : fetchData});
    }
    
    console.log(sum);
    
    useEffect(fetchData, []);
    
    
    // this.state = {
    //     data:{},
    // }
    
    // const { data } = this.state;



    return (

        


        //sedikit lagi nih kawan ..
        
     <StyleCard  >
        <div className="two__justfy">
        <div className="cards__items">
                <div  className="cards__one">
                    <h1>Positif</h1>
                    {/* <h1  className="cards__descOne" value="">{confirmed.data.value}</h1> */}

                    <h1  className="cards__descOne" value="">6,072,918</h1>
                </div> 
        </div>


       <div className="cards__items">
            <div  className="cards__two">
                <h1>Sembuh</h1>
                {/* <h1  className="cards__descTwo">{recovered.data.value}</h1> */}
               

                <h1  className="cards__descTwo">600,000</h1>
            </div>
        </div>

        <div  className="cards__items">
            <div  className="cards__two">
               <h1>Meninggal</h1>
                {/* <h1  className="cards__descTwo">{deaths.data.value}</h1> */}

               <h1 className="cards__descThree">156,000</h1> 
            </div>
        </div>   


    </div> 
     </StyleCard>
        
    )
}


export default Card;